<template>
  <div class="dept-page anCore-fill" v-loading="loading">
    <div class="panel panel-info dept-panel">
      <div class="panel-heading">
        <div class="panel-title">部门及人员</div>
      </div>
      <div class="panel-body dept-body">
        <div class="dept-col dept-tree">
          <ul class="dept-tree-list">
            <li
              v-for="node in flatTree"
              :key="node.value || node.name"
              :class="{ active: String(selectedId) === String(node.value) }"
              :style="{ paddingLeft: (12 + node.depth * 14) + 'px' }"
              @click="selectDept(node)"
            >
              <i class="fa fa-folder-o" /> {{ node.name }}
            </li>
          </ul>
        </div>
        <div class="dept-col dept-users">
          <div class="breadcrumb">{{ breadcrumb || '部门人员' }}</div>
          <div class="panel panel-success">
            <div class="panel-heading">
              <span>人员列表</span>
            </div>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th style="min-width:50px;">负责人</th>
                  <th style="min-width:50px;">姓名</th>
                  <th style="min-width:50px;">岗位</th>
                </tr>
              </thead>
              <tbody v-if="currentUsers.length">
                <tr v-for="u in currentUsers" :key="u.UserID">
                  <td>
                    <input type="radio" disabled :checked="!!u.isHeadman">
                  </td>
                  <td>{{ u.UserName }}</td>
                  <td>{{ u.postName || '—' }}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="3">
                    <div class="text-center text-muted" style="padding:50px 0;">
                      {{ selectedId ? '无' : '请选择部门' }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="dept-col dept-posts">
          <div class="breadcrumb">岗位</div>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>岗位名称</th>
              </tr>
            </thead>
            <tbody v-if="currentPosts.length">
              <tr v-for="p in currentPosts" :key="p.PostID">
                <td>{{ p.PostName }}</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td>
                  <div class="text-center text-muted" style="padding:40px 0;">暂无岗位</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loadIvanSyncJson } from '@/utils/ivanSync'

function flattenTree(nodes, depth = 0, out = []) {
  ;(nodes || []).forEach(n => {
    out.push({
      name: n.name,
      value: n.value,
      depth,
      isParent: !!n.isParent
    })
    if (n.children && n.children.length) flattenTree(n.children, depth + 1, out)
  })
  return out
}

export default {
  name: 'DeptManage',
  data() {
    return {
      loading: false,
      tree: [],
      users: [],
      posts: [],
      selectedId: null,
      breadcrumb: ''
    }
  },
  computed: {
    flatTree() {
      return flattenTree(this.tree)
    },
    currentPosts() {
      if (!this.selectedId) return []
      const id = Number(this.selectedId)
      return this.posts.filter(p => Number(p.DepartmentID) === id)
    },
    currentUsers() {
      if (!this.selectedId) return []
      const id = Number(this.selectedId)
      const rows = []
      this.users.forEach(u => {
        ;(u.DepartmentList || []).forEach(d => {
          if (Number(d.DepartmentID) === id) {
            rows.push({
              UserID: u.UserID,
              UserName: u.UserName,
              postName: (d.Post && d.Post.PostName) || '',
              isHeadman: !!d.IsHeadman
            })
          }
        })
      })
      return rows
    }
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const [tree, users, posts] = await Promise.all([
          loadIvanSyncJson('dept_tree.json'),
          loadIvanSyncJson('users.json'),
          loadIvanSyncJson('dept_posts.json')
        ])
        this.tree = Array.isArray(tree) ? tree : []
        this.users = Array.isArray(users) ? users : []
        this.posts = Array.isArray(posts) ? posts : []
        const firstLeaf = this.flatTree.find(n => n.value && !n.isParent)
        if (firstLeaf) this.selectDept(firstLeaf)
      } catch (e) {
        this.$message.error(e.message || '加载部门数据失败')
      } finally {
        this.loading = false
      }
    },
    selectDept(node) {
      if (!node || !node.value) return
      this.selectedId = node.value
      this.breadcrumb = node.name
    }
  }
}
</script>

<style scoped>
.dept-page { height: 100%; padding: 0; }
.dept-panel { margin: 0; height: 100%; min-width: 750px; }
.dept-body {
  display: flex;
  height: calc(100% - 48px);
  padding: 0;
}
.dept-col {
  overflow: auto;
  height: 100%;
  padding: 10px;
}
.dept-tree { width: 28%; border-right: 2px solid #eae1e1; }
.dept-users { width: 44%; border-right: 2px solid #eae1e1; }
.dept-posts { width: 28%; }
.dept-tree-list { list-style: none; margin: 0; padding: 0; }
.dept-tree-list li {
  cursor: pointer;
  padding: 6px 8px;
  color: #333;
}
.dept-tree-list li:hover { background: #f5f8fb; }
.dept-tree-list li.active { background: #e7f1f9; color: #337ab7; }
.breadcrumb { margin-bottom: 10px; }
</style>
